import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from 'components/BaseComponent';
import { selectWorks } from '../Api/selectors';

const CONTENT = {
  contact : '<h1>Contact pagina</h1>',
  work : '<h1>Vacatures</h1>',
  tuv : '<h1>TUV</h1>',
  terms : '<h1>Algemene voorwaarden</h1>',
  partners : '<h1>Partners</h1>', 
  privacy :'<h1>Privacy</h1>'
};

/* eslint-disable react/prefer-stateless-function */
class ContentsPageComp extends BaseComponent {

  constructor(props) {
    super(props, {   
    });
  }

  componentDidMount(){
    
  }

  render() {   
    return <><div dangerouslySetInnerHTML={{__html : CONTENT[this.props.content]}} /></>
    
  }

}

ContentsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  work : selectWorks([
    'contents_'
  ])
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    
  }
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ContentsPage = compose(
  withConnect,
  withRouter
)(ContentsPageComp);